import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UserSummarySettingsModel } from '../user-summary-settings.model';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { UserModel } from '../user.model';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiUserSharedService } from '@fi-shared/fi-user-shared/fi-user-shared.service';

@Component({
    selector: 'fi-user-summary-settings',
    templateUrl: './user-summary-settings.component.html',
    styleUrls: ['./user-summary-settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-summary-settings' },
    standalone: false,
})
export class UserSummarySettingsComponent implements OnInit {
    @Input() summarySettings: UserSummarySettingsModel;
    @Input() user: UserModel;
    IsChecklistAvailable: boolean;
    IsChecklistReportAvailable: boolean;
    IsUserRequestAvailable: boolean;
    IsNewPageAvailable: boolean;
    IsNewFileAvailable: boolean;
    IsPostAvailable: boolean;
    IsForumAvailable: boolean;
    IsFormAvailable: boolean;
    isUpdateSettingsShown: boolean = true;

    constructor(
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private detectDevicesService: DetectDevicesService,
        private customerDataService: FiCustomerDataService,
        private userService: FiUserSharedService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.IsChecklistAvailable = this.isApplicationTypeAvailable(ApplicationSettingsType.ChecklistLocal);
        //this.IsChecklistReportAvailable = this.isApplicationTypeAvailable(ApplicationSettingsType.CheckListReports);
        this.IsChecklistReportAvailable = false;
        this.IsUserRequestAvailable = this.isApplicationTypeAvailable(
            ApplicationSettingsType.CoreLocal,
            AccessRightType.Write,
        );
        this.IsNewPageAvailable = this.isApplicationTypeAvailable(ApplicationSettingsType.DocumentLocal);
        this.IsNewFileAvailable = this.isApplicationTypeAvailable(ApplicationSettingsType.MediaBankLocal);
        this.IsPostAvailable = this.isApplicationTypeAvailable(ApplicationSettingsType.PostLocal);
        this.IsForumAvailable = this.isApplicationTypeAvailable(ApplicationSettingsType.Forum);
        this.IsFormAvailable = this.isApplicationTypeAvailable(ApplicationSettingsType.FormLocal);
        this.setUpdateSettingsVisibility();
    }

    private isApplicationTypeAvailable(applicationType, accessLevel?) {
        return this.accessToApplicationTypeService.HasAccessToApplicationType(
            applicationType,
            accessLevel || AccessRightType.Read,
            this.user,
        );
    }

    isMobilePhone(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    setUpdateSettingsVisibility() {
        this.isUpdateSettingsShown = this.summarySettings.IsWeeklyFrequency || this.summarySettings.IsDailyFrequency;
    }

    //#region disable push flutter test content
    protected showDisablePushNotificationsContent() {
        return this.customerDataService.isTestCustomer();
    }

    protected disablePushNotificationsUntilDate: string;
    protected onGetDisablePushNotificationsUntilDateClick() {
        this.disablePushNotificationsUntilDate = undefined;
        this.userService.getDisablePushNotificationsUntilDate().then((untilDate) => {
            this.disablePushNotificationsUntilDate = untilDate;
            this.cdr.markForCheck();
        });
    }
    protected onSetDisablePushNotificationsUntilDateClick() {
        this.userService.setDisablePushNotificationsUntilDate(this.disablePushNotificationsUntilDate);
    }
    //#endregion
}
